<div ngbDropdown placement="bottom auto" autoClose="outside" class="kt-header__topbar-item">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<span class="kt-header__topbar-icon"
			[ngClass]="{'kt-pulse kt-pulse--brand': pulse, 'kt-pulse--light' : pulseLight, 'kt-header__topbar-icon--success' : iconType === 'success'	}">
			<!-- <i *ngIf="!useSVG" [ngClass]="icon"></i> -->

			<mat-icon class="m-menu-icon" >alarm</mat-icon>
	
			<!-- <span *ngIf="useSVG" class="kt-svg-icon" [ngClass]="{'kt-svg-icon--success' : iconType === 'success'}" [inlineSVG]="icon"></span> -->

			<span class="kt-pulse__ring" [hidden]="!pulse"></span>
		</span>
		<!-- <span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand" [hidden]="!dot"></span>
		 -->



		<span *ngIf="activeProcesses>0"
			class="kt-badge  kt-badge--notify kt-badge--sm  kt-badge--accent">{{activeProcesses}}</span>

	</div>

	<div ngbDropdownMenu
		class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
		<form>
			<!--begin: Head -->
			<div class="kt-head kt-head--skin-{{skin}} "
				[ngStyle]="{'background-image': backGroundStyle() }">
				<h3 class="kt-head__title">
					Aguardando&nbsp;
					<span class="btn btn-{{ type }} btn-sm btn-bold btn-font-md">{{activeProcesses}} tarefas</span>
				</h3>
				<ul ktTabClickEvent
					class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-{{ type }} kt-notification-item-padding-x"
					role="tablist">
				
				</ul>
			</div>
			<!--end: Head -->

			<ul ngbNav class="nav-tabs" #nav="ngbNav">
				<li ngbNavItem  id="tab-id-1">
					<!-- <ng-template ngbNavContent>  -->
						<div 
						[ngStyle]="{'max-height': '40vh', 'position': 'relative'}"
							class="kt-notification kt-margin-t-10 kt-margin-b-10  elegant-scroll-y">

							<div *ngIf="activeProcesses>0 ; else emptyTasks">
								<a  routerLink="/customers/lotteries/{{task.LotteryId}}/bets/details/{{task.cryptoBetId}}"
								 *ngFor="let task of tasks" href="javascript:;" class="kt-notification__item">
									<div class="kt-notification__item-icon">
										<i class="flaticon2-line-chart kt-font-success"></i>
									</div>
									<div class="kt-notification__item-details">
										<div class="kt-notification__item-title">
											{{task.description}}
										</div>
										<div class="kt-notification__item-time">
											Inicio:{{task.createDate | date:'dd/MM/yyyy HH:mm:ss'}}
											Servidor:{{task.machineId}}
											Tarefa:{{task.taskTypeName}}
										</div>
									</div>
								</a>
							</div>
							<ng-template #emptyTasks>
								<div class="kt-grid kt-grid--ver" style="min-height: 200px;">
									<div
										class="kt-grid kt-grid--hor kt-grid__item kt-grid__item--fluid kt-grid__item--middle">
										<div class="kt-grid__item kt-grid__item--middle kt-align-center" >
											Sem tarefas aguardando...
										
										</div>
									</div>
								</div>
							</ng-template>

							<div class="ps__rail-x" style="left: 0px; bottom: 0px;">
								<div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
							</div>
							<div class="ps__rail-y" style="top: 0px; right: 0px;">
								<div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
							</div>
						</div>
					 <!-- </ng-template> -->
				</li>
				
				</ul> 
		</form>
	</div>
</div>